<div class="filter-container">
  <button
    mat-icon-button
    type="button"
    class="dropdown-filter-button"
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="menu"
    (click)="fillMenu(false)"
  >
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <mat-form-field class="filter-search">
    <mat-chip-grid #chipList>
      <mat-chip-row
        *ngFor="let selChip of currentChips"
        [removable]="true"
        (removed)="removeChip(selChip)"
        color="primary"
        selected="true"
        (click)="fillMenu(true)"
      >
        {{ selChip.label }}
        <mat-icon matChipRemove class="chip-icon">cancel</mat-icon>
      </mat-chip-row>
      <input
        placeholder="Filtern..."
        class="filter-input"
        #filterInput
        [formControl]="inputCtrl"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      />
    </mat-chip-grid>
    <mat-menu class="overview-filter-menu" #menu="matMenu">
      <div *ngIf="isSchadenTab" (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon class="filter-icon">receipt</mat-icon>
        <mat-form-field class="compact-form-field">
          <input class="mat-input-element" matInput type="text" placeholder="Schadennummer" [(ngModel)]="schadenNr"
                 (keyup.enter)="applyFilter()"/>
        </mat-form-field>
      </div>
      <div *ngIf="!isSchadenTab" (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon class="filter-icon">receipt</mat-icon>
        <mat-form-field class="compact-form-field">
          <input class="mat-input-element" matInput type="text" placeholder="Polizzennummer" [(ngModel)]="polizzenNr"
                 (keyup.enter)="applyFilter()"/>
        </mat-form-field>
      </div>
      <div (click)="$event.stopPropagation()" mat-menu-item class="overview-daterange-input">
        <mat-icon (click)="schadendatumPicker.open()" class="overview-daterange-icon filter-icon">date_range</mat-icon>
        <mat-form-field class="compact-form-field">
          <mat-date-range-input [formGroup]="schadendatumRangeGroup" [rangePicker]="schadendatumPicker">
            <input
              [(ngModel)]="schadendatumStart"
              placeholder="von "
              formControlName="start"
              class="overview-daterange-input_start"
              matStartDate
            />
            <input [(ngModel)]="schadendatumEnd" placeholder=" bis" formControlName="end" matEndDate
                   (keyup.enter)="applyFilter()"/>
          </mat-date-range-input>
          <mat-date-range-picker #schadendatumPicker></mat-date-range-picker>
          <mat-error *ngIf="schadendatumRangeGroup.controls.start.hasError('matStartDateInvalid')"></mat-error>
          <mat-error *ngIf="schadendatumRangeGroup.controls.end.hasError('matEndDateInvalid')"></mat-error>
        </mat-form-field>
      </div>
      <div *ngIf="isSchadenTab" (click)="$event.stopPropagation()" mat-menu-item class="overview-daterange-input">
        <mat-icon (click)="meldedatumPicker.open()" class="overview-daterange-icon filter-icon">date_range</mat-icon>
        <mat-form-field class="compact-form-field">
          <mat-date-range-input [formGroup]="meldedatumRangeGroup" [rangePicker]="meldedatumPicker">
            <input
              [(ngModel)]="meldedatumStart"
              formControlName="start"
              class="overview-daterange-input_start"
              matStartDate
              placeholder="von "
            />
            <input [(ngModel)]="meldedatumEnd" formControlName="end" matEndDate placeholder=" bis"
                   (keyup.enter)="applyFilter()"/>
          </mat-date-range-input>
          <mat-date-range-picker #meldedatumPicker></mat-date-range-picker>
          <mat-error *ngIf="meldedatumRangeGroup.controls.start.hasError('matStartDateInvalid')"></mat-error>
          <mat-error *ngIf="meldedatumRangeGroup.controls.end.hasError('matEndDateInvalid')"></mat-error>
        </mat-form-field>
      </div>
      <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon class="filter-icon">list</mat-icon>
        <mat-form-field class="compact-form-field">
          <input class="mat-input-element" matInput placeholder="Vertragssparte" [(ngModel)]="vertragssparte"
                 (keyup.enter)="applyFilter()"/>
        </mat-form-field>
      </div>
      <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon class="filter-icon">person_outline</mat-icon>
        <mat-form-field class="compact-form-field">
          <input class="mat-input-element" matInput placeholder="Kundenname" [(ngModel)]="kundenName"
                 (keyup.enter)="applyFilter()"/>
        </mat-form-field>
      </div>
      <div *ngIf="isSchadenTab" (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon class="filter-icon">check_box</mat-icon>
        <mat-form-field class="compact-form-field">
          <mat-select [(ngModel)]="schadenStatus" placeholder="Status">
            <mat-option *ngFor="let status of stati" value="{{ status }}">{{ status }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="isSchadenTab" (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon class="filter-icon">check_box</mat-icon>
        <mat-form-field class="compact-form-field">
          <mat-select [(ngModel)]="checklisteStatus" placeholder="Checkliste">
            <mat-option *ngFor="let cStatus of checklisteStati"
                        value="{{ cStatus }}">{{ convertToCheckListStatusText(cStatus) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="isKbma" (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon class="filter-icon">apps</mat-icon>
        <mat-form-field class="compact-form-field">
          <input class="mat-input-element" matInput placeholder="Betreuernummer" [(ngModel)]="betreuerNummer"
                 (keyup.enter)="applyFilter()"/>
        </mat-form-field>

      </div>
      <div *ngIf="isARGE" (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon class="filter-icon">person</mat-icon>
        <mat-form-field class="compact-form-field">
          <input class="mat-input-element" matInput placeholder="Benutzer" [(ngModel)]="benutzer"
                 (keyup.enter)="applyFilter()"/>
        </mat-form-field>

      </div>
      <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <button mat-raised-button type="button" class="filter-button" color="accent" (click)="applyFilter()">
          Filtern
        </button>
      </div>
    </mat-menu>
  </mat-form-field>
</div>
